<template>
  <div>
    <datatable
      :title="getTitle"
      :show_delete="false"
      @thFilter="thFilter"
      @create="createAlert"
      @edit_click="editClick"
      @past="toggleQueryParam('past')"
      @future="toggleQueryParam('future')"
      @allAlertsNow="updateAllAlerts()"
      @doneAllAlerts="updateDoneAllAlerts()"
      @nullAlertsOwner="updateNullAlertsOwner()"
      :working_th_searches="working_th_searches"
      :unique_buttons="unique_buttons"
      :operations="operations"
      :filters="filters"
      :sorters="sorters"
      :fields="fields"
      :response="data"
      :show_header_filter="false"
      >
    </datatable>
  </div>
</template>
<script>
import { mapMutations, mapGetters, mapActions } from 'vuex'
import TimeHelper from '@/custom/classes/time_helper.js'
import FiltersHelper from '@/custom/classes/filters_helper.js'
import DataTable from '@/components/DataTable.vue'
export default {
  name: 'admin-alerts',
  data () {
    let filters_helper = new FiltersHelper()
    return {
      time_helper: new TimeHelper(),
      filters_helper: filters_helper,
      fields: [
        {
          name: 'content',
          value: 'content',
          component: 'AlertContent'
        },
        {
          name: 'alert_message',
          value: 'message',
          component: 'Message',
          additional_data: {
            resource_type: 'Alert',
            endpoint: '/alerts/',
            headers: 'admin_headers'
          }
        },
        {
          name: 'owner',
          value: 'owner',
          component: 'TableCellOwner'
        },
        {
          name: 'resource',
          value: 'resources',
          component: 'AlertResourceCell'
        },
        {
          name: 'timing',
          value: 'timing',
          component: 'TableCellTiming'
        },
        {
          name: 'priority',
          value: 'priority'
        },
        {
          name: 'applicant_last_login',
          value: 'resources.applicant.last_login',
          is_time: true
        },
        {
          name: 'created_at',
          value: 'created_at',
          is_time: true
        },
        {
          name: 'id',
          value: 'id'
        }
      ],
      sorters: [
        {
          designator: 'owner',
          value: '-owner'
        },
        {
          designator: 'priority',
          value: '-priority'
        },
        {
          designator: 'timing',
          value: '-timing'
        }
      ],
      filters: [
        {
          type: 'single',
          designator: 'statuses',
          options: [
            {
              text: 'active',
              value: 'active'
            },
            {
              text: 'done',
              value: 'done'
            },
            {
              text: 'in_progress',
              value: 'in_progress'
            },
            {
              text: 'irrelevant',
              value: 'irrelevant'
            }
          ]
        },
        {
          type: 'multiple',
          designator: 'designators',
          options: this.designatorOptions
        },
        {
          type: 'single',
          designator: 'owner',
          options: this.dropdownAdmins
        }
      ],
      unique_buttons: [
        {
          name: 'allAlertsNow',
          display_text: 'now all alerts',
          css_classes: {
            'is-danger is-outlined': () => true,
            'is-hidden': () => this.permiteAllAlertsNow
          }
        },
        {
          name: 'doneAllAlerts',
          display_text: 'done all alerts',
          css_classes: {
            'is-danger is-outlined': () => true,
            'is-hidden': () => this.permiteAllAlertsNow
          }
        },
        {
          name: 'nullAlertsOwner',
          display_text: 'null alerts owner',
          css_classes: {
            'is-danger is-outlined': () => true,
            'is-hidden': () => this.permiteAllAlertsNow
          }
        },
        {
          name: 'past',
          display_text: 'PAST',
          css_classes: {
            'is-info': () => this.$route.query.past
          }
        },
        {
          name: 'future',
          display_text: 'FUTURE',
          css_classes: {
            'is-info': () => this.$route.query.future
          }
        }
      ],
      schedule_of_the_day: [],
      interval: {},
      th_filters: {},
      data: [],
      operations: [
        { component: 'AlertDoneButton' },
        { component: 'AlertPlusMinusButton' },
        { component: 'FeedOffer' }
      ],
      working_th_searches: ['owner', 'full_name', 'company_name', 'position_title']
    }
  },
  computed: {
    getSelectedDesignatorGroupName () {
      for (let i = 0; i < this.feedDesignators.length; i++) {
        let feed_designator = this.feedDesignators[i]
        if (this.$route.query.designators == feed_designator.designators) {
          return feed_designator.group
        }
      }
      if (this.$route.query.title) {
        return this.$route.query.title
      }
      return undefined
    },
    getTitle () {
      return this.getSelectedDesignatorGroupName || 'Feed'
    },
    permiteAllAlertsNow () {
      const permission_level = this.$utils.getOwner().permission_level
      return ![0, 8, 9, 10].includes(permission_level)
    },
    ...mapGetters('admins', ['dropdownAdmins']),
    ...mapGetters('feedDesignators', ['feedDesignators', 'designatorOptions'])
  },
  watch: {
    dropdownAdmins (oldValue, newValue) {
      this.filters.forEach(filter => {
        if (filter.designator === 'owner') {
          filter.options = newValue
        }
      })
    },
    designatorOptions (oldValue, newValue) {
      this.filters.forEach(filter => {
        if (filter.designator === 'designators') {
          filter.options = newValue
        }
      })
    }
  },
  beforeDestroy () {
    clearInterval(this.interval)
  },
  created () {
    this.init()
    this.fetchAll()
  },
  mounted () {
    document.title = this.getTitle
  },
  methods: {
    init () {
      this.getAlerts()
    },
    thFilter (th_filters) {
      this.th_filters = th_filters
      this.getAlerts()
    },
    updateAllAlerts () {
      const designators = this.$route.query.designators
      this.$network_utils.massUpdateAlert({ id: '-1', now_all_alerts: 'true', feed_designators_string: designators, owner: this.$utils.getOwner().name }).then(r => {
        this.$utils.emit('show_toast', { text: 'שונה בהצלחה' })
      })
    },
    updateDoneAllAlerts () {
      const designators = this.$route.query.designators.split(',').join(',')
      if (confirm('האם את/ה בטוח/ה שתרצה לסיים את כלל המשימות ?')) {
        this.$network_utils.massUpdateAlert({ id: '-1', done_all_alerts: 'true', feed_designators_string: designators }).then(r => {
          this.$utils.emit('show_toast', { text: 'שונה בהצלחה' })
        })
      }
    },
    updateNullAlertsOwner () {
      const designators = this.$route.query.designators
      if (confirm('האם את/ה בטוח/ה שתרצה לאפס את הowner?')) {
        this.$network_utils.massUpdateAlert({ id: '-1', null_alerts_owner: 'true', feed_designators_string: designators }).then(r => {
          this.$utils.emit('show_toast', { text: 'שונה בהצלחה' })
        })
      }
    },
    getAlerts () {
      this.$network_utils
        .getAllAlerts({
          sort: this.$route.query.sort,
          page: this.$route.query.page || 1,
          per: 100,
          empty_priority: this.$route.query.empty_priority,
          timing: new Date().toUTCString(),
          past: this.$route.query.past,
          future: this.$route.query.future,
          group_by_applicant: this.$route.query.group_by_applicant ? 'TRUE' : undefined,
          ...this.filters_helper.getServerCallFilters(this.filters),
          ...this.th_filters
        })
        .then(response => {
          this.data = response
        })
    },
    selectDesignatorGroup (group_name, additional_query_params) {
      if (this.getSelectedDesignatorGroupName == group_name) {
        return
      }
      this.$router.push({ name: this.$route.name, query: { ...this.$route.query, designators: this.getDesignatorsListByGroupName(group_name).join(','), ...additional_query_params } })
    },
    toggleQueryParam (param_name) {
      let query = { ...this.$route.query }
      let query_param = query[param_name]
      let new_param = ''
      if (query_param == undefined || query_param.toString() == 'false') {
        new_param = true
      }
      if (query_param != undefined && query_param.toString() == 'true') {
        new_param = undefined
      }
      query[param_name] = new_param
      this.$router.push({ name: this.$route.name, query })
    },
    getDesignatorsListByGroupName (group_name) {
      return this.feedDesignators.filter(feed_designator => feed_designator.group == group_name)[0].designators
    },
    compareByTiming (a, b) {
      if (a.timing > b.timing) {
        return -1
      }
      if (b.timing < a.timing) {
        return 0
      }
      return 1
    },
    createAlert () {
      this.create({ designator: 'alert-form-modal', component_name: 'AlertForm', is_create: true, modal_title: 'Create new Item' })
    },
    editClick (data) {
      let title_data = ''
      if (data.resource_type) {
        title_data = data.resource_type == 'Offer' ? data.resources : data.resources[data.resource_type.toLowerCase()]
      }
      this.create({ designator: 'alert-form-modal', component_name: 'AlertForm', data, modal_title: this.$utils.getResourceFullName({ resource_type: data.resource_type, data: title_data }) })
    },
    ...mapActions('admins', ['fetchAll']),
    ...mapMutations('modals', ['create'])
  },
  components: {
    datatable: DataTable
  }
}
</script>
